import api from "./Api";

class ProdutoService {
  GetProduto(payload) {
    return api.get("/v1/Produto/" + payload).then((response) => {
      return response.data;
    });
  }

  PostProduto(payload) {
    return api.post("/v1/Produto/", payload).then((response) => {
      return response.data;
    });
  }

  PutProduto(payload) {
    return api.put("/v1/Produto/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteProduto(payload) {
    return api.delete("/v1/Produto/" + payload).then((response) => {
      return response.data;
    });
  }

  GetProdutoOData(payload) {
    return api.get("/OData/Produto" + payload).then((response) => {
      return response.data;
    });
  }

  GerarCodigoBarras() {
    return api.get("/v1/Produto/GerarCodigoBarras").then((response) => {
      return response.data;
    });
  }

  GetProdutoMultiempresaGrade(payload) {
    return api
      .post("/v1/Produto/Multiempresa/Grade", payload)
      .then((response) => {
        return response.data;
      });
  }

  GetRelatorio(payload) {
    return api.post("/v1/Produto/GetRelatorio", payload).then((response) => {
      return response.data;
    });
  }

  ConsultarGestorTributos(payload) {
    return api
      .post("/v1/Produto/ConsultarGestorTributos", payload, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        return response.data;
      });
  }

  GetGestorTributosConsultasOData(payload) {
    return api
      .get("/v1/Produto/GestorTributos/Consultas" + payload)
      .then((response) => {
        return response.data;
      });
  }

  PostGestorTributosConsulta() {
    return api.post("/v1/Produto/GestorTributos/Consultas").then((response) => {
      return response.data;
    });
  }

  GetGestorTributosPendencias(payload) {
    return api
      .get("/v1/Produto/GestorTributos/Pendencias", {
        params: { filtro: payload || "" },
      })
      .then((response) => response.data);
  }

  GetGestorTributosPendenciasOData(payload) {
    return api
      .get("/v1/Produto/GestorTributos/Pendencias" + payload)
      .then((response) => response.data);
  }

  PesquisarGestorTributosImendes(payload) {
    return api
      .get("/v1/Produto/GestorTributos/Pendencias/PesquisarImendes", {
        params: { termo: payload },
      })
      .then((response) => response.data);
  }

  RelacionarGestorTributos(payload) {
    return api
      .post("/v1/Produto/GestorTributos/Pendencias/Relacionar", payload)
      .then((response) => response.data);
  }

  ConsultarRelacionamentoGestorTributos(payload) {
    return api
      .post(
        "/v1/Produto/GestorTributos/Pendencias/Relacionar/Consultar",
        payload
      )
      .then((response) => response.data);
  }

  Validate(payload) {
    return api.post("/v1/produto/Validate/", payload).then((response) => {
      return response.data;
    });
  }

  Converter(payload) {
    return api.post("/v1/produto/Converter/", payload).then((response) => {
      return response.data;
    });
  }
}

export default new ProdutoService();
